import { Component, OnInit, Input, Output, EventEmitter, DoCheck } from '@angular/core';

import { OdometroHorimetroApiService } from "../shared/odometro-horimetro-api.service";
import { OdometroHorimetroService } from "../shared/odometro-horimetro.service";

@Component({
    selector: 'app-odometro-horimetro-form-component',
    template: require('./odometro-horimetro-form.component.html'),
    styles: [require('./odometro-horimetro-form.component.css')]
})
export class OdometroHorimetroFormComponent implements OnInit, DoCheck {
    @Input() labelOdometro: string = '';
    @Input() labelHorimetro: string = '';
    @Input() showOdometro: boolean = true;
    @Input() submitted: boolean = false;
    @Input() required: boolean = false;
    @Input() model: any;
    @Input() bemId: number;
    @Output() returnModel: EventEmitter<any> = new EventEmitter() ;

    lastOdometroHorimetro: number;

    private lasBemId: number = 0;

    constructor(
        private _odometroHorimetroApiService: OdometroHorimetroApiService,
        private _odometroHorimetroService: OdometroHorimetroService
    ){}

    ngOnInit() {}

    ngDoCheck() {
        if (this.bemId && (this.bemId !== this.lasBemId)) {
            this.lasBemId = this.bemId;
            this.getLastOdometroHorimetro();
        }
    }

    changeModel() {
        let t: string = this._odometroHorimetroService.setMask(this.model);
        this.returnModel.emit(t);
    }

    getLastOdometroHorimetro() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                let y = this._odometroHorimetroService.setMask(Response.odometroHorimetro);
                this.lastOdometroHorimetro = y;
            } else {
                this.lastOdometroHorimetro = '';
            }
        }.bind(this));

        this._odometroHorimetroApiService.onGetLast(this.bemId, onDone);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/odometros-horimetros/odometro-horimetro-form/odometro-horimetro-form.component.ts
 **/